import { HomeScreenThemeSizeConfig } from './types';

const small: HomeScreenThemeSizeConfig = {
  homeScreen: {},
};

export default small;
